// https://icsc.test/api/carousel
export default {
    data: [
        {
            background_image: 'https://icsc.test/uploads/carousel/1018-730x350.jpg',
            button_text: 'Join the conversation',
            link: '/test',
            title: 'Welcome to ICSC Virtual Community',
        },
        {
            background_image: 'https://icsc.test/uploads/carousel/1040-730x350.jpg',
            button_text: '',
            link: '',
            title: 'This is Another Slide',
        },
    ],
};
